import React from 'react';
import {
	getFormattedDateWithTimestamp,
	getDetailLink,
} from '../../../lib/helpers/index';
import styles from './ProposalRow.module.scss';
import { LinkObjectType } from '../../../lib/helpers/types';
import { gql, DocumentNode } from '@apollo/client';
import { AcceptProposalModalRowProposalFragment } from '#types';
import { Box, ListItem, ListItemText, Typography } from '@mui/material';
import { Button } from '../../Button';
import { preferredDayJsDateFormat } from '../../../lib/constants';

const acceptProposalModalRowProposalFragment = gql`
	fragment acceptProposalModalRowProposal on Proposal {
		id
		title
		guestToken
		dueDate
	}
`;

export type ProposalRowProps = {
	proposal: AcceptProposalModalRowProposalFragment;
	onNavigate?: () => any;
};

type ProposalRowPropsWithFragment = React.FC<ProposalRowProps> & {
	fragments: {
		acceptProposalModalRowProposalFragment: DocumentNode;
	};
};

interface LinkParam {
	token?: string;
}

const ProposalRow: ProposalRowPropsWithFragment = ( {
	proposal,
	onNavigate,
} ) => {
	if ( !proposal ) {
		return null;
	}

	const linkObject = proposal;
	const linkParams: LinkParam = {
		...( proposal.guestToken ? { token: proposal.guestToken } : {} ),
	};
	const link = getDetailLink( {
		object: linkObject,
		params: linkParams,
		type: LinkObjectType.Proposal,
	} );

	const dueDate = getFormattedDateWithTimestamp(
		proposal.dueDate,
		preferredDayJsDateFormat
	);

	return (
		<ListItem disableGutters>
			<ListItemText className={ styles.proposalDetails }>
				<Typography className={ styles.title } component='span'>
					{ proposal.title }
				</Typography>
				<Box component='span' className={ styles.item }>
					<Typography component='span' className={ styles.itemText }>
						Due
					</Typography>
					<Typography
						component='span'
						className={ styles.itemText }
						data-label='Due'
					>
						{ dueDate }
					</Typography>
				</Box>
			</ListItemText>
			{ link ? (
				<Button
					{ ...link }
					onClick={ onNavigate }
					className={ styles.button }
					data-cy={ `accept-proposal-btn-${ proposal.id }` }
				>
					view
				</Button>
			) : null }
		</ListItem>
	);
};

ProposalRow.fragments = {
	acceptProposalModalRowProposalFragment,
};

export default ProposalRow;
